/*
document.addEventListener("DOMContentLoaded", function(){
  // Handler when the DOM is fully loaded
});
*/

window.onload = function() {  




        /* 버튼에 직접 세팅한 이벤트 처리 부분 ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ */
          
          // <!-- Event snippet for Add to cart conversion page
          // In your html page, add the snippet and call gtag_report_conversion when someone clicks on the chosen link or button. -->
          function gtag_report_conversion(url,current_price) {

            var callback = function () {
              if (typeof(url) != 'undefined') {
                window.location = url;
              }
            };
            
            /*
            // [OLD]
            gtag('event', 'conversion', {
                'send_to': 'AW-10831842533/fYDBCPuOjY4DEOWZg60o',
                'value': current_price,
                'currency': 'USD',
                'event_callback': callback
            });
            */
            
            // [2022-05-04]
            gtag('event', 'conversion', {
                'send_to': 'AW-10876067858/WHz5CM-0h7oDEJLAjsIo',
                'value': current_price,
                'currency': 'USD',
                'event_callback': callback
            });            
            
            
            //console.log(url);
            //console.log(current_price);
            
            return false;
          }



          var elmtClass = document.getElementsByClassName("ga_evt");
          Array.prototype.forEach.call(elmtClass, function(element) {
            element.addEventListener("click", function() {

              var ga_cate = this.dataset.ga_cate;
              var ga_action = this.dataset.ga_action;
              var ga_label = this.dataset.ga_label;

              //console.log(ga_cate+','+ga_action+','+ga_label);


              //ga('send','event',ga_cate,ga_action,ga_label);
              try {
                ga('send','event',ga_cate,ga_action,ga_label);
              } catch {
                //
              }
                
                
              // 장바구니 담기
                if(ga_action == 'AddToCart') {
                  //var current_price = Math.round(this.dataset.ga_current_price / 100);
                  var current_price = this.dataset.ga_current_price;
                  //console.log(current_price);
                  
                  //var url = window.location.href;
                  var url = undefined;
                  //console.log(url);
                  gtag_report_conversion(url,current_price);
                }

            });
          });


}






// <!-- Event snippet for Add to cart conversion page
// In your html page, add the snippet and call gtag_report_conversion when someone clicks on the chosen link or button. -->
function gtag_report_conversion_2(url,current_price) {

  var callback = function () {
    if (typeof(url) != 'undefined') {
      window.location = url;
    }
  };

  // [OLD]
  /*
  gtag('event', 'conversion', {
    'send_to': 'AW-10831842533/fYDBCPuOjY4DEOWZg60o',
    'value': current_price,
    'currency': 'USD',
    'event_callback': callback
  });
  */

  // [2022-05-04]
  gtag('event', 'conversion', {
    'send_to': 'AW-10876067858/WHz5CM-0h7oDEJLAjsIo',
    'value': current_price,
    'currency': 'USD',
    'event_callback': callback
  });            

  
  //console.log(url);
  //console.log(current_price);

  return false;
}


function click_addToCart(ga_cate,ga_action,ga_label,current_price) {

    //console.log('click ==> ' + ga_cate+','+ga_action+','+ga_label+','+current_price);
    try {
      ga('send','event',ga_cate,ga_action,ga_label);
    } catch {
      //
    }

    // 장바구니 담기
    if(ga_action == 'AddToCart') {
      //var current_price = Math.round(this.dataset.ga_current_price / 100);
      //var current_price = this.dataset.ga_current_price;
      //console.log(current_price);

      //var url = window.location.href;
      var url = undefined;
      //console.log(url);
      gtag_report_conversion_2(url,current_price);
    }

}


